import { Component, OnDestroy, OnInit, forwardRef, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { WorkflowComponent } from '../../../../workflow.component';
//import { DomainCodes } from '../../../../../../models/const.DomainCodes';
//import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';


@Component({
  selector: 'payment',
  templateUrl: './payment.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class PaymentComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy, OnChanges {

  @Input("cardData")
  public cardData: models.PaymentVM = {} as models.PaymentVM;


  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  @Input("bankAccountTypes")
  public bankAccountTypes: models.DimensionVM[];
  @Input("yesNo")
  public yesNo: models.DimensionVM[];
  @Input()
  countryCode: string;

  public parentWorkflow: WorkflowComponent;

  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component, private modalService: ModalService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData =(<any>parent)._cardData;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.countryCode.currentValue != null && changes?.countryCode.previousValue!==undefined ) {
      if (changes?.countryCode.currentValue != changes?.countryCode.previousValue) {
        this.cardData.bankAccount = null;
        this.cardData.iban = null;
        this.cardData.isSoleHolder = null;
      }
    }
  }

  ngOnInit(): void {
    const a = this.bankAccountTypes
  }

  ngOnDestroy(): void {
  }

  onBankAccountChanged() {
    if (this.cardData.bankAccount == "I") {
      this.cardData.iban = null;
    }
  }


  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }
}
